import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { CgProfile } from 'react-icons/cg';
import { FiUserPlus } from 'react-icons/fi';
import { VscChecklist } from 'react-icons/vsc';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoLogOut } from 'react-icons/io5';

export const PROFILE_DROPDOWN_CONFIG = {
  notLogged: [
    {
      name: 'text190',
      href: () => ROUTES.SIGN_IN(),
      icon: (
        <CgProfile
          size={24}
          className="text-foreground group-hover:text-white group-focus:text-white"
        />
      ),
      hardLink: false,
    },
    {
      name: 'text261',
      href: () => ROUTES.REGISTER(),
      icon: (
        <FiUserPlus
          size={24}
          className="text-foreground group-hover:text-white group-focus:text-white"
        />
      ),
      hardLink: false,
    },
  ],
  logged: [
    {
      name: 'text491',
      href: () => ROUTES.MY_DATA(),
      icon: (
        <CgProfile
          size={24}
          className="text-foreground group-hover:text-white group-focus:text-white"
        />
      ),
      hardLink: false,
    },
    {
      name: 'text2361',
      href: () => ROUTES.ORDERS(),
      icon: (
        <VscChecklist
          size={24}
          className="text-foreground group-hover:text-white group-focus:text-white"
        />
      ),
      hardLink: false,
    },
    {
      name: 'text115',
      href: () => ROUTES.CHANGE_PASSWORD(),
      icon: (
        <RiLockPasswordLine
          size={24}
          className="text-foreground group-hover:text-white group-focus:text-white"
        />
      ),
      hardLink: false,
    },
    {
      name: 'text258',
      href: () => ROUTES.SIGN_OUT(),
      icon: (
        <IoLogOut
          size={24}
          className="-scale-x-[1] text-foreground group-hover:text-white group-focus:text-white"
        />
      ),
      hardLink: true,
    },
  ],
};
